var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkUnreadChatAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_9720",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_9720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.175 15.58H20V7.48751C20.3833 7.40425 20.7417 7.29169 21.075 7.14982C21.4083 7.00862 21.7167 6.82146 22 6.58834V15.58C22 16.1295 21.8043 16.6001 21.413 16.9917C21.021 17.3827 20.55 17.5782 20 17.5782H6L2 21.5745V3.59112C2 3.04163 2.196 2.57106 2.588 2.17942C2.97933 1.78845 3.45 1.59297 4 1.59297H14.1C14.0333 1.92599 14 2.25902 14 2.59204C14 2.92507 14.0333 3.25809 14.1 3.59112H4V16.7539L5.175 15.58ZM6 13.5819H14V11.5837H6V13.5819ZM6 10.5846H18V8.58649H6V10.5846ZM6 7.58742H18V7.48751C17.3833 7.3543 16.8207 7.12518 16.312 6.80015C15.804 6.47578 15.3667 6.07215 15 5.58927H6V7.58742ZM19 5.58927C18.1667 5.58927 17.4583 5.29787 16.875 4.71508C16.2917 4.13228 16 3.42461 16 2.59204C16 1.75948 16.2917 1.0518 16.875 0.469009C17.4583 -0.113785 18.1667 -0.405182 19 -0.405182C19.8333 -0.405182 20.5417 -0.113785 21.125 0.469009C21.7083 1.0518 22 1.75948 22 2.59204C22 3.42461 21.7083 4.13228 21.125 4.71508C20.5417 5.29787 19.8333 5.58927 19 5.58927Z",
    fill: "#453F3A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkUnreadChatAlt);
export default __webpack_public_path__ + "static/media/mark_unread_chat_alt.1b30cc5fed9c2f9cd2f6920dad51792b.svg";
export { ForwardRef as ReactComponent };